window.scheduleTalk = () => {
    return {
        // now: Date.now(),
        isOpen: false,
        startDate: "",
        endDate: "",
        is20MinBeforeLive: false,
        isBeforeLive: false,
        isAfterLive: false,
        isLive: false,

        init() {
            this._setState();
            if (!this.isAfterLive) {
                setInterval(() => {
                    this._setState();
                }, 1000);
            }
        },

        _setState() {
            const startDate = new Date(this.startDate * 1000);
            const now = Date.now();

            startDate.setMinutes(startDate.getMinutes() - 20);
            this.is20MinBeforeLive = now < this.startDate * 1000 && now >= startDate.getTime();

            this.isBeforeLive = now < this.startDate * 1000;
            this.isAfterLive = now >= this.endDate * 1000;
            this.isLive = now >= this.startDate * 1000 && now <= this.endDate * 1000;
        },

        open() {
            document.querySelector(".schedule-content").classList.add("schedule-more-active");
            this.isOpen = true;
        },

        close() {
            document.querySelector(".schedule-content").classList.remove("schedule-more-active");
            this.isOpen = false;
        }
    };
};
